import React from 'react'
import PropTypes from 'prop-types'
import OrderSubscription from './OrderSubscription'
import { PlatinumRewardsLogo } from '../../core/icons'

function PlatinumSubscription(props) {
  const {
    order, platinumSubscription, checkoutStep, handlePlatinumAdded, ...rest
  } = props

  const mainText = () => {
    const strongText = order.user && order.user['platinum?'] ? `You will earn ${order.earnable_platinum_points_currency} back in points on this purchase` : `Earn ${order.earnable_platinum_points_currency} back in points on this purchase`
    const openingText = order.user && order.user['platinum?'] ? null : 'and 10% back on every purchase going forward (plus there are many other perks too) '

    return (
      <span>
        <strong>{strongText} </strong> <span> {openingText}</span>
      </span>
    )
  }

  return (
    <OrderSubscription
      logo={<PlatinumRewardsLogo className="order-sub-image" />}
      mainText={mainText()}
      checkText={order.user && order.user['platinum?'] ? null : <span>Enroll for $25/yr</span>}
      subText={order.user && order.user['platinum?'] ? null : <div>Platinum Rewards subscription will be activated when you complete this order.</div>}
      subscription={platinumSubscription}
      order={order}
      checkoutStep={checkoutStep}
      handlePlatinumAdded={handlePlatinumAdded}
    />
  )
}

PlatinumSubscription.defaultProps = {
  order: {},
  platinumSubscription: {},
  checkoutStep: '',
  handlePlatinumAdded() {},
}

PlatinumSubscription.propTypes = {
  // The order that is being placed
  order: PropTypes.object,
  // The platinum subscription plan
  platinumSubscription: PropTypes.object,
  // The step of checkout
  checkoutStep: PropTypes.string,
  // Function to change pricing if platinum sub is added
  handlePlatinumAdded: PropTypes.func,
}

export default PlatinumSubscription
